// @flow
import React, { Component } from "react";
import Link from "gatsby-link";
import logo from "../../images/tb-mark.svg";
import container from "../../styles/container.module.css";
import styles from "./Header.module.css";

type Props = {
  siteTitle: string
};

class Header extends Component<Props, void> {
  render() {
    const { siteTitle } = this.props;
    return (
      <div className={styles.header}>
        <div className={container.default}>
          <Link to="/">
            <img src={logo} alt={siteTitle} className={styles.logo} />
          </Link>
        </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js